export default __webpack_public_path__ + "static/media/Blog4_2.863f88a7.jpg";